import { get, post, remove, tokenStore } from '../../shared/api/http';

export type TicketStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface Ticket {
  id: string;
  status: TicketStatus;
  note: string | null;
  reason: string | null;
  createdAt: string;
  reviewedAt: string | null;
  reviewedBy: { id: string; name: string } | null;
  issuedCount: number;
  player: { id: string; externalId: string; name: string };
  mission: { id: string; key: string; labelEs: string; labelPt: string; qty: number };
  numbers: string[];
}

/** Fila de validação dos comprovantes (missões manuais). */
export const ticketsApi = {
  list: (status?: TicketStatus): Promise<Ticket[]> => get(`/tickets${status ? `?status=${status}` : ''}`),
  counts: (): Promise<Record<TicketStatus, number>> => get('/tickets/counts'),
  approve: (id: string): Promise<Ticket> => post(`/tickets/${id}/approve`),
  reject: (id: string, reason: string): Promise<Ticket> => post(`/tickets/${id}/reject`, { reason }),
  remove: (id: string): Promise<void> => remove(`/tickets/${id}`),
  /** A imagem exige o token, então vira um blob URL (revogar com URL.revokeObjectURL). */
  async imageUrl(id: string): Promise<string> {
    const res = await fetch(`/api/tickets/${id}/image`, { headers: { Authorization: `Bearer ${tokenStore.get() ?? ''}` } });
    if (!res.ok) throw new Error(`imagem ${res.status}`);
    return URL.createObjectURL(await res.blob());
  },
};
